(function($) {

  Drupal.behaviors.hero_tout_mobile_v1 = {
    attach: function(context, settings) {
      if ( $('#video-local-container').length ) {
        if ( $('#video-local-thumbnail').length ) {
          $('#video-local-thumbnail').click(function() {
            $('#video-local')[0].play();
            $('#video-local')[0].webkitRequestFullscreen();
          });
        } else {
          if ( $('.hero-tout-mobile__hero--a').length ) {
            if ( $('.hero-tout-mobile__hero--a img').length ) {
              $(".hero-tout-mobile__content--a").click(function() {
                $('#video-local')[0].play();
                $('#video-local')[0].webkitRequestFullscreen();
              });
            }
          }
          if ( $('.hero-tout-mobile__hero--b').length ) {
            if ( $('.hero-tout-mobile__hero--b img').length ) {
              $(".hero-tout-mobile__content--b").click(function() {
                $('#video-local')[0].play();
                $('#video-local')[0].webkitRequestFullscreen();
              });
            }
          }
        }
      }

    }
  };

})(jQuery);